import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Step3Component } from './step-3/step-3.component';
import { Step4Component } from './step-4/step-4.component';
import { InternationalComponent } from './international/international.component';
import { Step5Component } from './step-5/step-5.component';
import { Step1Component } from './step-1/step-1.component';
import { ViewCancelReservationComponent } from './view-cancel-reservation/view-cancel-reservation.component';
import { Step2Component } from './step-2/step-2.component';
import { CouponPromotionsComponent } from './coupon-promotions/coupon-promotions.component';
import { PrecheckinComponent } from './landings/precheckin/precheckin.component';
import { FaqPageComponent } from './faq-page/faq-page.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { DestinationAirportComponent } from './destination-airport/destination-airport.component';
import { DestinationLocationsComponent } from './destination-locations/destination-locations.component';
import { CountryComponent } from './country/country.component';
import { CityComponent } from './city/city.component';
import { CustomerSupportComponent } from './landings/customer-support/customer-support.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { EnterprisesComponent } from './enterprises/enterprises.component';
import { RentalPolicyComponent } from './landings/rental-policy/rental-policy.component';
import { TermsUseComponent } from './landings/terms-use/terms-use.component';
import { PrivacyPolicyComponent } from './landings/privacy-policy/privacy-policy.component';
import { RefundsPolicyComponent } from './landings/refunds-policy/refunds-policy.component';
import { TermsConditionsComponent } from './landings/terms-conditions/terms-conditions.component';
import { StandardOfCareComponent } from './landings/standard-of-care/standard-of-care.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { isEnabledPreCheckin } from '@/common/guards/isEnabledPreCheckin';
import { isEnabledViewCancelReservation } from '@/common/guards/isEnabledViewCancelReservation';
import { AdditionalCategoriesServicesComponent } from './additional-categories-services/additional-categories-services.component';
import { MetaGuard } from '@/common/guards/MetaGuard';
import { ReservationGuard } from '@/common/guards/reservationGuard';
import { SpecialOffersEmailComponent } from './special-offers-email/special-offers-email.component';
import { LandingVacationComponent } from './landings/landing-vacation/landing-vacation.component';
import { RentalFlexibleComponent } from './landings/rental-flexible/rental-flexible.component';
import { LeaseComponent } from './landings/lease/lease.component';
import { LeasingComponent } from './landings/leasing/leasing.component';
import { TypesCarComponent } from './landings/types-car/types-car.component';
import { AlamoRewardsComponent } from './alamo-rewards/alamo-rewards.component';
import { EnterprisesLpComponent } from './enterprises-lp/enterprises-lp.component';
import { TypPageComponent } from './landings/typ/typ.component';
import { CoveragesComponent } from './landings/coverages/coverages.component';

const routes: Routes = [
    {
        path: '',
        component: Step1Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title',
                description: 'fe_meta_seo_description',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'renta-de-autos-en-Cancun/rentar-auto-en-Aeropuerto-Intl-de-Cancun',
        component: Step1Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title',
                description: 'fe_meta_seo_description',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'renta-de-autos-en-Ciudad-de-Mexico/rentar-auto-en-Aeropuerto-Intl-de-la-Ciudad-de-Mexico-T1',
        component: Step1Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title',
                description: 'fe_meta_seo_description',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'renta-de-autos-en-Ciudad-de-Mexico/rentar-auto-en-Aeropuerto-Nal-de-la-Ciudad-de-Mexico-T1',
        component: Step1Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title',
                description: 'fe_meta_seo_description',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'renta-de-autos-en-Monterrey/rentar-auto-en-Aeropuerto-Intl-Gral-Mariano-Escobedo',
        component: Step1Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title',
                description: 'fe_meta_seo_description',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservaciones/categorias-y-vehiculos',
        component: Step2Component,
        canActivate: [MetaGuard, ReservationGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_cars-and-categories',
                description: 'fe_meta_seo_description_cars-and-categories',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservations/cars-and-categories',
        component: Step2Component,
        canActivate: [MetaGuard, ReservationGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_cars-and-categories',
                description: 'fe_meta_seo_description_cars-and-categories',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'pre-check-in',
        component: PrecheckinComponent,
        canActivate: [isEnabledPreCheckin, MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_pre-check-in',
                description: 'fe_meta_seo_description_pre-check-in',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'contact-us-and-faqs',
        component: CustomerSupportComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_en_contact-us-and-faqs',
                description: 'fe_meta_seo_description_contact-us-and-faqs',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'contacto',
        component: CustomerSupportComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_contact-us-and-faqs',
                description: 'fe_meta_seo_description_contact-us-and-faqs',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'preguntas/condiciones-y-politicas-de-renta',
        component: RentalPolicyComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_car-rental-conditions-and-policies',
                description:
                    'fe_meta_seo_description_car-rental-conditions-and-policies',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'questions/car-rental-conditions-and-policies',
        component: RentalPolicyComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_en_car-rental-conditions-and-policies',
                description:
                    'fe_meta_seo_description_car-rental-conditions-and-policies-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'preguntas/terminos-de-uso',
        component: TermsUseComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_terms-of-use',
                description: 'fe_meta_seo_description_terms-of-use',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'questions/terms-of-use',
        component: TermsUseComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_questions_terms-of-use',
                description: 'fe_meta_seo_description_terms-of-use-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'questions/terms-and-conditions',
        component: TermsConditionsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_questions_terms-and-conditions',
                description: 'fe_meta_seo_description_terms-and-conditions-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'preguntas/terminos-y-condiciones',
        component: TermsConditionsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_terms-and-conditions',
                description: 'fe_meta_seo_description_terms-and-conditions',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'coberturas-y-protecciones',
        component: CoveragesComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_coverages',
                description: 'fe_meta_seo_description_coverages',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'coverages-and-protections',
        component: CoveragesComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_coverages',
                description: 'fe_meta_seo_description_coverages',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'preguntas/aviso-de-privacidad',
        component: PrivacyPolicyComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_privacy-policy',
                description: 'fe_meta_seo_description_privacy-policy',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'questions/privacy-policy',
        component: PrivacyPolicyComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_en_privacy-policy',
                description: 'fe_meta_seo_description_privacy-policy-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'questions/refunds-policy',
        component: RefundsPolicyComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_refunds-policy',
                description: 'fe_meta_seo_description_refunds-policy-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'preguntas/politicas-de-reembolso',
        component: RefundsPolicyComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_refunds-policy',
                description: 'fe_meta_seo_description_refunds-policy',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'pre-check-in/reservaciones',
        loadChildren: () =>
            import('./pre-check-in/precheckin.module').then(
                (c) => c.PrecheckinModule,
            ),
        canActivate: [isEnabledPreCheckin],
    },
    {
        path: 'pre-check-in/reservations',
        loadChildren: () =>
            import('./pre-check-in/precheckin.module').then(
                (c) => c.PrecheckinModule,
            ),
        canActivate: [isEnabledPreCheckin],
    },
    {
        path: 'reservaciones_internacionales/busqueda-sucursales',
        component: InternationalComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_international-branch-search',
                description:
                    'fe_meta_seo_description_international-branch-search',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'international-reservations/branch-search',
        component: InternationalComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_international-branch-search',
                description:
                    'fe_meta_seo_description_international-branch-search',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservaciones/productos-y-servicios',
        component: Step3Component,
        canActivate: [MetaGuard, ReservationGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_trip-enhancements',
                description: 'fe_meta_seo_description_trip-enhancements',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservations/trip-enhancements',
        component: Step3Component,
        canActivate: [MetaGuard, ReservationGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_trip-enhancements',
                description: 'fe_meta_seo_description_trip-enhancements',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservaciones/resumen',
        component: Step4Component,
        canActivate: [MetaGuard, ReservationGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_reservation-summary',
                description: 'fe_meta_seo_description_reservation-summary',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservations/reservation-summary',
        component: Step4Component,
        canActivate: [MetaGuard, ReservationGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_reservation-summary',
                description: 'fe_meta_seo_description_reservation-summary',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'reservaciones/reservacion-confirmada',
        component: Step5Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_reservation-complete',
                description: 'fe_meta_seo_description_reservation-complete',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'reservations/reservation-complete',
        component: Step5Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_reservation-complete',
                description: 'fe_meta_seo_description_reservation-complete',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'reservaciones/consultar-reservacion',
        component: Step5Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_reservation-information',
                description: 'fe_meta_seo_description_reservation-information',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'reservations/reservation-information',
        component: Step5Component,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_reservation-information',
                description: 'fe_meta_seo_description_reservation-information',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'consulta-tu-reservacion',
        component: ViewCancelReservationComponent,
        canActivate: [isEnabledViewCancelReservation, MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_check-your-reservation',
                description: 'fe_meta_seo_description_check-your-reservation',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'check-your-reservation',
        component: ViewCancelReservationComponent,
        canActivate: [isEnabledViewCancelReservation, MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_en_check-your-reservation',
                description:
                    'fe_meta_seo_description_check-your-reservation',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'promociones-y-convenios',
        component: PromotionsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_promos-and-agreements',
                description: 'fe_meta_seo_description_promos-and-agreements',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'promos-and-agreements',
        component: PromotionsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_en_promos-and-agreements',
                description: 'fe_meta_seo_description_promos-and-agreements-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'promociones-y-convenios/:coupon',
        component: CouponPromotionsComponent,
        canActivate: [MetaGuard],
        data: {
            origin: 'promotions',
            meta: {
                title: 'fe_meta_seo_title_promos-and-agreements-landing',
                description:
                    'fe_meta_seo_description_promos-and-agreements-landing',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'promos-and-agreements/:coupon',
        component: CouponPromotionsComponent,
        canActivate: [MetaGuard],
        data: {
            origin: 'promotions',
            meta: {
                title: 'fe_meta_seo_title_promos-and-agreements-landing',
                description:
                    'fe_meta_seo_description_promos-and-agreements-landing',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'renta-un-auto/:coupon',
        component: CouponPromotionsComponent,
        canActivate: [MetaGuard],
        data: {
            origin: 'landing',
            meta: {
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'rent-a-car/:coupon',
        component: CouponPromotionsComponent,
        canActivate: [MetaGuard],
        data: {
            origin: 'landing',
            meta: {
                title: 'fe_meta_seo_title_rent-a-car-coupon',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'preguntas',
        component: FaqPageComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_questions',
                description: 'fe_meta_seo_description_questions',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'questions',
        component: FaqPageComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_questions',
                description: 'fe_meta_seo_description_questions-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'sobre-nosotros',
        component: AboutUsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_about-us',
                description: 'fe_meta_seo_description_about-us',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'about-us',
        component: AboutUsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_about-us',
                description: 'fe_meta_seo_description_about-us',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'destino-aeropuerto/:code',
        component: DestinationAirportComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_destination-airport-{code}',
                description:
                    'fe_meta_seo_description_destination-airport-{code}',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'destination-airport/:code',
        component: DestinationAirportComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_destination-airport-{code}',
                description:
                    'fe_meta_seo_description_destination-airport-{code}-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'destinos-y-sucursales',
        children: [
            {
                path: '',
                component: DestinationLocationsComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_locations-and-offices',
                        description:
                            'fe_meta_seo_description_locations-and-offices',
                        keywords: 'fe_meta_seo_keywords',
                        robots: 'fe_meta_seo_robots',
                    },
                },
            },
            {
                path: ':code',
                component: CityComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_locations-and-offices-{code}',
                        description:
                            'fe_meta_seo_description_locations-and-offices-{code}',
                        keywords: 'fe_meta_seo_keywords',
                        robots: 'fe_meta_seo_robots',
                    },
                },
            },
        ],
    },
    {
        path: 'locations-and-offices',
        children: [
            {
                path: '',
                component: DestinationLocationsComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_en_locations-and-offices',
                        description:
                            'fe_meta_seo_description_locations-and-offices',
                        keywords: 'fe_meta_seo_keywords',
                        robots: 'fe_meta_seo_robots',
                    },
                },
            },
            {
                path: ':code',
                component: CityComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_locations-and-offices',
                        description:
                            'fe_meta_seo_description_locations-and-offices',
                        keywords: 'fe_meta_seo_keywords',
                        robots: 'fe_meta_seo_robots',
                    },
                },
            },
        ],
    },
    {
        path: 'pais',
        component: CountryComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_country',
                description: 'fe_meta_seo_description_country',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'country',
        component: CountryComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_country',
                description: 'fe_meta_seo_description_country-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'destino-aeropuerto/:code/ciudad',
        component: CityComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_destination-airport-{code}-city',
                description:
                    'fe_meta_seo_description_destination-airport-{code}-city',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'destination-airport/:code/city',
        component: CityComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_destination-airport-{code}-city',
                description:
                    'fe_meta_seo_description_destination-airport-{code}-city-en',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'empresas',
        children: [
            {
                path: '',
                component: EnterprisesLpComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_corporate',
                        description: 'fe_meta_seo_description_corporate',
                        keywords: 'fe_meta_seo_keywords',
                        robots: 'fe_meta_seo_robots',
                    },
                },
            },
            {
                path: 'renta-flexible',
                component: RentalFlexibleComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_renta-flexible',
                        description: 'fe_meta_seo_description_renta-flexible',
                    },
                },
            },
            {
                path: 'alamo-arrendamiento',
                component: LeaseComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_alamo-lease',
                        description: 'fe_meta_seo_description_alamo-lease',
                    },
                },
            },
            {
                path: 'alamo-leasing',
                component: LeasingComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_leasing',
                        description: 'fe_meta_seo_description_leasing',
                    },
                },
            },
            {
                path: 'alamo-tipos-autos',
                component: TypesCarComponent,
                canActivate: [MetaGuard],
                data: {
                    meta: {
                        title: 'fe_meta_seo_title_types_car',
                        description: 'fe_meta_seo_description_types_car',
                    },
                },
            },
        ],
    },
    {
        path: 'empresas-old',
        component: EnterprisesComponent,
    },

    {
        path: 'about-us/our-standard-of-care',
        component: StandardOfCareComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_our-standard-of-care',
                description:
                    'fe_meta_seo_description_our-standard-of-care-es-1',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'about-us-a/our-standard-of-care',
        component: StandardOfCareComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_our-a-standard-of-care',
                description:
                    'fe_meta_seo_description_our-standard-of-care-en-2',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'acerca-de-nosotros/nuestro-estandar-de-cuidado',
        component: StandardOfCareComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_our-standard-of-care',
                description:
                    'fe_meta_seo_description_our-standard-of-care-es-1',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'sobre-nosotros/nuestro-estandar-de-cuidado',
        component: StandardOfCareComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_our-standard-of-care',
                description:
                    'fe_meta_seo_description_our-standard-of-care-es-2',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'site-under-maintenance',
        component: MaintenanceComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_inner_pages',
                description: 'fe_meta_seo_description_inner_pages',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'sitio-en-mantenimiento',
        component: MaintenanceComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_inner_pages',
                description: 'fe_meta_seo_description_inner_pages',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots_noindex_nofollow',
            },
        },
    },
    {
        path: 'additional-categories-and-services',
        component: AdditionalCategoriesServicesComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_additional-categories-and-services',
                description:
                    'fe_meta_seo_description_additional-categories-and-services',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'categorias-y-servicios-adicionales',
        component: AdditionalCategoriesServicesComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_additional-categories-and-services',
                description:
                    'fe_meta_seo_description_additional-categories-and-services',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'ofertas-especiales-correo',
        component: SpecialOffersEmailComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: '',
                description: '',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'devacacionesconalamo',
        component: LandingVacationComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: '',
                description: '',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'alamo-rewards',
        component: AlamoRewardsComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_alamo-rewards',
                description: 'fe_meta_seo_description_alamo-rewards',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
    {
        path: 'typ-empresas',
        component: TypPageComponent,
        canActivate: [MetaGuard],
        data: {
            meta: {
                title: 'fe_meta_seo_title_corporate',
                description: 'fe_meta_seo_description_corporate',
                keywords: 'fe_meta_seo_keywords',
                robots: 'fe_meta_seo_robots',
            },
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PagesRoutingModule {}
